import { useState } from "react";
import { usePWAInstall } from "@/hooks/usePWAInstall";
import { X, ExternalLink } from "lucide-react";

export default function OpenInAppBanner() {
  const { showOpenInApp } = usePWAInstall();
  const [dismissed, setDismissed] = useState(false);

  if (!showOpenInApp || dismissed) return null;

  const handleOpen = () => {
    // Best-effort: navigate to start_url hoping OS intercepts for installed PWA
    window.location.href = "/app/dashboard?source=pwa";
  };

  return (
    <div className="fixed top-0 inset-x-0 z-50 bg-primary text-primary-foreground px-4 py-2 flex items-center justify-between gap-2 text-sm" style={{ paddingTop: "max(0.5rem, env(safe-area-inset-top))" }}>
      <div className="flex items-center gap-2 min-w-0">
        <ExternalLink className="h-4 w-4 shrink-0" />
        <span className="truncate">Open in ACEX App</span>
      </div>
      <div className="flex items-center gap-1 shrink-0">
        <button onClick={handleOpen} className="rounded-md bg-primary-foreground/20 px-3 py-1 text-xs font-medium hover:bg-primary-foreground/30 transition-colors">
          Open
        </button>
        <button onClick={() => setDismissed(true)} className="p-1 hover:bg-primary-foreground/20 rounded-full transition-colors" aria-label="Dismiss">
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}
